import { Env } from '@kouto/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const HyattWaiver = () => {
  const { t } = useTranslation();

  let hyattLinkToWaver = '';

  switch (process.env.NODE_ENV) {
    case Env.PRODUCTION:
      hyattLinkToWaver =
        'https://storage.googleapis.com/kouto-api-static-live/woh-experiences-waiver.pdf';
      break;
    case Env.PREVIEW:
    case Env.STAGING:
      hyattLinkToWaver =
        'https://storage.googleapis.com/kouto-api-static-staging/woh-experiences-waiver.pdf';
      break;
    case Env.TEST:
    case Env.DEVELOPMENT:
      hyattLinkToWaver =
        'https://storage.googleapis.com/kouto-api-static-testing/woh-experiences-waiver.pdf';
      break;
    default:
      hyattLinkToWaver =
        'https://storage.googleapis.com/kouto-api-static-testing/woh-experiences-waiver.pdf';
      break;
  }

  return (
    <div style={{ marginTop: '10px' }}>
      {t('hyattWaiverText')}
      {` `}
      <a href={hyattLinkToWaver} target="_blank" rel="noreferrer">
        {t('hyattWaiverLink')}
      </a>
      .
    </div>
  );
};

export default HyattWaiver;
